module.exports = __webpack_public_path__ + "04_long_grey.c09d8d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/04_long_grey.png
// module id = CPJI
// module chunks = 0